import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import {CommonModal, FormErrors} from 'components/common';
import ReaderTable from '../User/ReaderTable';
import ReaderCreationForm from '../User/ReaderCreationForm';
import {fetchUsers, setCurrentUserPage, clearUsersAfterPage} from 'actions/users';
import {fetchCurrentAccount} from 'actions/account';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';
import {createReader} from 'api/users';

class ParentDashBoard extends React.Component {
  static propTypes = {
    userPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      refreshTableKey: 0,
      errors: {},
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  showModal() {
    this.setState({
      modalShown: true,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
    });
  }

  handleSubmit(data) {
    const {fetchCurrentAccount, addFlashMessage, formatErrors} = this.props;
    createReader({
      ...data,
      level: isEmpty(data.level) ? null : data.level.value,
    })
      .then(() => {
        this.setState((prevState) => ({
          modalShown: false,
          refreshTableKey: prevState.refreshTableKey + 1,
        }));
        fetchCurrentAccount();
        addFlashMessage('New reader account successfully created!', 'success');
      })
      .catch((err) =>
        formatErrors(err).then((errors) => {
          this.setState({
            errors,
          });
        }),
      );
  }

  render() {
    const {errors, modalShown, refreshTableKey} = this.state;
    const {userPages, fetchUsers, setCurrentUserPage, clearUsersAfterPage} = this.props;
    return (
      <div>
        <CommonModal title="Create New Student" onClose={this.closeModal} show={modalShown}>
          <FormErrors errors={errors} />
          <ReaderCreationForm onSubmit={this.handleSubmit} />
        </CommonModal>
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Students</div>
              <Button variant="contained" color="primary" className="pull-right" onClick={this.showModal}>
                Create Student
              </Button>
            </h3>
            <ReaderTable
              {...{
                refreshTableKey,
                recordPages: userPages,
                fetchRecords: fetchUsers,
                setCurrentRecordPage: setCurrentUserPage,
                clearRecordsAfterPage: clearUsersAfterPage,
              }}
            />
          </Panel>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userPages: state.users.get('userPages').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
  fetchUsers: (...args) => dispatch(fetchUsers(...args)),
  setCurrentUserPage: (...args) => dispatch(setCurrentUserPage(...args)),
  clearUsersAfterPage: (...args) => dispatch(clearUsersAfterPage(...args)),
  fetchCurrentAccount: (...args) => dispatch(fetchCurrentAccount(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParentDashBoard);
